import { registerAnalytics } from "@humansignal/core";
registerAnalytics();

import { bootstrap } from "./boot/bootstrap";
import { OIDC_ENABLED, userManager } from "./boot/oidc";
import "./utils/service-worker";
import "./utils/state-registry-lso";

async function init() {
  try {
    // Handle OIDC callback when returning from Zitadel
    if (OIDC_ENABLED && window.location.pathname === "/oidc/callback") {
      console.log("[LS] Handling OIDC callback...");
      const { renderCallback } = await import("./pages/Callback/CallbackPage");
      renderCallback();
      return;
    }

    console.log("[LS] Starting bootstrap...");
    const authenticated = await bootstrap();
    console.log("[LS] Bootstrap result:", authenticated);

    if (authenticated) {
      console.log("[LS] Loading app...");
      await import("./app/App");
    } else if (OIDC_ENABLED) {
      // Redirect to Zitadel login
      console.log("[LS] Redirecting to Zitadel...");
      await userManager?.signinRedirect();
    } else {
      // Fallback to email+password login
      console.log("[LS] Loading login page...");
      const { renderLogin } = await import("./pages/Login/Login");
      renderLogin();
    }
  } catch (err) {
    console.error("[LS] Init failed:", err);
    const root = document.querySelector(".app-wrapper");
    if (root) {
      root.innerHTML = `<pre style="padding:20px;color:red">Init error: ${err}</pre>`;
    }
  }
}

init();
